import { useParams, useNavigate } from 'react-router-dom';
import BookingSteps from '@/components/service-booking/booking-steps';
import { setWebTitle } from '@/lib/format-utils';
import { useTranslation } from 'react-i18next';

export default function ServiceBookingPage() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const { t } = useTranslation();

    setWebTitle(`${t('service_booking')} #${id}`);

    if (!id) return null;

    return (
        <BookingSteps
            serviceBookingId={id}
            opened={true}
            onClose={() => navigate(-1)} // Alternatively navigate(SERVICE_BOOKINGS_PATH)
        />
    );
}
